<template>
  <v-container grid-list-md fluid>
    <v-layout row wrap>
      <v-flex md12>
        <v-card>
          <v-flex d-flex md12 >
            <v-form>
              <v-layout row wrap>
                <v-flex d-flex xs12 sm6 md12>
                  <v-layout row wrap>
                    <v-flex d-flex md6>
                      <v-text-field 
                        v-show="view.elem.input.clave.visible"
                        v-if="!view.action.submit.busy" 
                        v-model="$v.sucursal.clave.$model"
                        :disabled="view.elem.input.clave.disabled"
                        :error-messages="getFirstErrorDescription($v.sucursal.clave)"
                        :label="$t('view.global.common.clave')" >
                      </v-text-field>
                    </v-flex>
                    <v-flex md6></v-flex>
                    <v-flex d-flex md6 >
                        <v-text-field 
                        v-model="$v.sucursal.numeroComercio.$model"
                        :error-messages="getFirstErrorDescription($v.sucursal.numeroComercio)"
                        :label="$t('view.comercio.numeroComercio')" >
                      </v-text-field>
                    </v-flex>
                    <v-flex md6>
                      <!-- <v-text-field 
                        v-model="$v.sucursal.summitterId.$model"
                        :error-messages="getFirstErrorDescription($v.sucursal.summitterId)"
                        :label="$t('view.comercio.summitterId')" >
                      </v-text-field> -->
                    </v-flex>
                    <!-- <v-flex d-flex md6 > -->
                      <!-- <v-card-text> -->
                        <v-flex d-flex md6>
                          <v-text-field
                            v-model="$v.sucursal.name.$model"
                            :error-messages="getFirstErrorDescription($v.sucursal.name)"
                            :label="$t('view.comercio.name')" >
                          </v-text-field>
                        </v-flex>
                        <v-flex d-flex md6>
                          <v-text-field
                            v-model="$v.sucursal.email.$model"
                            :error-messages="getFirstErrorDescription($v.sucursal.email)"
                            :label="$t('view.global.common.email')" >
                          </v-text-field>
                        </v-flex>
                        <v-flex d-flex md6>
                          <v-text-field
                            v-model="$v.sucursal.locationAddress.$model"
                            :error-messages="getFirstErrorDescription($v.sucursal.locationAddress)"
                            :label="$t('view.comercio.direccion')" >
                          </v-text-field>
                        </v-flex>
                        <v-flex d-flex md6>
                          <v-text-field
                            v-model="$v.sucursal.locationCity.$model"
                            :error-messages="getFirstErrorDescription($v.sucursal.locationCity)"
                            :label="$t('view.comercio.ciudad')" >
                          </v-text-field>
                        </v-flex>
                        <v-flex d-flex md3>
                          <v-text-field
                            v-model="$v.sucursal.locationRegionCode.$model"
                            :error-messages="getFirstErrorDescription($v.sucursal.locationRegionCode)"
                            :label="$t('view.comercio.region')" >
                          </v-text-field>
                        </v-flex>
                        <v-flex d-flex md3>
                          <v-text-field
                            v-model="$v.sucursal.locationCountryCode.$model"
                            :error-messages="getFirstErrorDescription($v.sucursal.locationCountryCode)"
                            :label="$t('view.comercio.codigoPais')" >
                          </v-text-field>
                        </v-flex>
                        <v-flex d-flex md3>
                          <v-text-field
                            v-model="$v.sucursal.locationPostalCode.$model"
                            :error-messages="getFirstErrorDescription($v.sucursal.locationPostalCode)"
                            :label="$t('view.comercio.cp')" >
                          </v-text-field>
                        </v-flex>
                        <v-flex d-flex md3>
                          <v-text-field
                            v-model="$v.sucursal.consecutivoArchivosGenerados.$model"
                            readonly
                            :error-messages="getFirstErrorDescription($v.sucursal.consecutivoArchivosGenerados)"
                            :label="$t('view.comercio.consecutivoArchivos')" >
                          </v-text-field>
                        </v-flex>
                        <v-flex d-flex md3>
                          <v-text-field
                            type="number"
                            v-model="$v.sucursal.mcc.$model"
                            :error-messages="getFirstErrorDescription($v.sucursal.mcc)"
                            :label="$t('view.comercio.mcc')" >
                          </v-text-field>
                        </v-flex>
                        
                        <!-- <v-flex d-flex md12>
                            <v-radio-group row :label="$t('view.comercio.tipoArchivo')"
                            :error-messages="getFirstErrorDescription($v.comercio.tipoArchivo)" 
                            v-model="$v.comercio.tipoArchivo.$model" >
                            <div v-for="(tipoArchivo,key) in view.elem.radio.tipoArchivo.options">
                              <v-radio  :label="tipoArchivo.name" :key="key" :value="tipoArchivo.code"></v-radio>
                            </div>
                            </v-radio-group>
                        </v-flex> -->
                        <!-- <v-flex d-flex md3>
                            <v-switch  
                            input-value="true" 
                            color="primary"
                            :label="`${$t('view.comercio.multipleSucursal')} ${$v.comercio.multipleSucursal.$model ? 'on' : 'off'}`" 
                            v-model="$v.comercio.multipleSucursal.$model" >
                            </v-switch>
                        </v-flex> -->
                        
                        <v-flex md3>
                          <v-text-field
                            v-model="$v.sucursal.nombreArchivoCartRefresh.$model"
                            :error-messages="getFirstErrorDescription($v.sucursal.nombreArchivoCartRefresh)"
                            :label="$t('view.comercio.nombreArchivoCartRefresh')" >
                          </v-text-field>
                        </v-flex>
                        <v-flex md3>
                          <v-text-field
                            v-model="$v.sucursal.nombreArchivoCartRefreshCarga.$model"
                            :error-messages="getFirstErrorDescription($v.sucursal.nombreArchivoCartRefreshCarga)"
                            :label="$t('view.comercio.nombreArchivoCartRefreshCarga')" >
                          </v-text-field>
                        </v-flex>
                        <v-flex d-flex md3>
                          <v-switch  
                          input-value="true" 
                          color="primary"
                          :label="`${$t('view.global.common.status')} ${$v.sucursal.status.$model ? 'on' : 'off'}`" 
                          v-model="$v.sucursal.status.$model" >
                          </v-switch>
                        </v-flex>
                        
                      <!-- </v-card-text> -->
                    <!-- </v-flex> -->
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-form>
          </v-flex>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-flex shrink>
              <v-tooltip v-show="view.elem.button.clear.visible" top>
                <v-btn 
                  @click="askForClear()" 
                  :loading="view.action.submit.busy" 
                  icon slot="activator" color="primary" large>
                  <v-icon>clear</v-icon>
                </v-btn>
                <span>{{$t('view.global.common.cancel')}}</span>
              </v-tooltip>
              <v-tooltip v-show="view.elem.button.audit.visible && $userPermission.hasPermission('ROLE_ACCESO_AUDITORIA')" top>
                <v-btn 
                  @click="showAudit()" 
                  :loading="view.action.submit.busy" 
                  icon slot="activator" color="primary" large>
                  <v-icon>storage</v-icon>
                </v-btn>
                <span>{{$t('view.global.common.auditoria')}}</span>
              </v-tooltip>
              <v-tooltip v-show="$userPermission.hasPermission(view.elem.button.submit.permission)" top>
                <v-btn 
                  :disabled="form.$state.isDisableButtonSubmit()"
                  :loading="view.action.submit.busy" 
                  @click="submit()" 
                  color="primary"
                  icon slot="activator"  large>
                  <v-icon>check</v-icon>
                </v-btn>
                <span>{{submitTitle}}</span>
              </v-tooltip>
            </v-flex>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <data-table ref="sucursalTable" :comercio="comercio" @editRow="loadSucursal" @auditRow="showAudit"  ></data-table>
    <auditoria ref="auditModal"></auditoria>
  </v-container>  
</template>

<script>
  import {required, maxLength,email,numeric, minValue,maxValue} from "vuelidate/lib/validators";
  import {allValidatorMethods} from "@/helpers/vuelidate";
  import {urlFTP, alphaNumDot, emailList, isCleanEspecialCharacter} from '@/helpers/vuelidate/validators'
  import {SucursalModel} from "@/models/generales/sucursal";
  import SucursalStates from "@/views/generales/comercio/sucursal-states"
  import {getErrors,getBusinessCode,getResponseDTO,handleResponseMessage} from '@/helpers/http-response-handler';
  import * as R from "ramda";
  import DataTable from "@/views/generales/comercio/SucursalDataTable";
  import Auditoria from "@/components/auditoria/Auditoria";
  import VueContentLoading from 'vue-content-loading';
  import CombosAPI from "@/services/catalogos";
  //Element's Settings
  const button = {
    submit:{
      enable:true
      , text:""
      , class:{
        current:""
        , save:"button__icon icon fa fa-plus"
        , update:"button__icon icon fa fa-check"
      }
      , data:{
        title:{
          current:"",
          save:"Guardar",
          update:"Actualizar"
        }
      }
      , permission: "ROLE_AGREGAR_COMERCIO"
    }
    , clear:{
      visible:true
    }
    , audit:{
      visible:true
    }
  };
  const modal = {
    rolePrivileges:{
      htmlElement:undefined
      , modal:undefined
      , privilegioTitle:""
    }
  }
  const input = {
    clave :{
      disabled:true
      , visible: false
    }
  }
 
  //Action's state
  const action = {
    submit:{
      busy:false
    }
    , privileges:{
      busy:false
    }
  };

  export default {
    name: "Sucursal",
    props:['comercio'],
    head:{
      title:function(){
        return {
          inner       : this.view.title
          , separator : '|'
          , complement: this.$t("view.home.system.initials")
        }
      }
    }
    , data(){
      let _locale = this.$store.language;
      return {
        locale: _locale
        , sucursal: undefined
        , form : new Object()
        , view:{
          title: this.$t("view.sucursal.title")
          , action
          , elem:{
            button
            , modal
            , input
            , showForm: true
          }
        }
      }
    }
    , methods: {
      ...allValidatorMethods
      , async submit(){
        try{
          const respuesta = await this.form.$state.submit(this.sucursal);
          const responseDTO = getResponseDTO(respuesta);
          handleResponseMessage({response: respuesta,modulo:this.name})
          this.form.$setState('editing',responseDTO.sucursal);
        }catch(error){
        }
      }
      , askForClear(){
        this.form.$state.askForClear();
      }
      , async showAudit(id=this.sucursal.clave,dataDescripcion=this.sucursal.name){

        this.$refs.auditModal.loadAudit({clave:id,tabla:'TComercioSucursal',descripcion:dataDescripcion,revision:null});
      }
      , async loadSucursal(idSucursal){
        try{
          const respuesta = await this.form.$state.load({clave:idSucursal});
          const responseDTO = getResponseDTO(respuesta);
          //handleResponseMessage({response: respuesta,modulo:this.name})
          this.form.$setState('editing',responseDTO.sucursal)
        }catch(error){
          // console.log(error)
        }
      }
      , createComponent(){
        this.form = new SucursalStates(this);
        this.form.$setState('initial');
      }      
    }
    , computed:{
      submitClass(){
        return this.view.elem.button.submit.class.current
      },
      submitTitle(){

        return this.view.elem.button.submit.data.title.current
      }
    }
    , validations:{
      sucursal:{
        clave:{
          required:false
        }
        , name:{
          required
          , maxLength : maxLength(200)
          , isCleanEspecialCharacter
        }
        , email:{
          required
          , emailList:emailList(';')
          , maxLength : maxLength(1000)
          
        }
        // , tipoArchivo:{
        //   required
        // }
        , status:{
          required
        }
        // , urlBuzonEntrada:{
        //   required
        // }
        // ,usuarioBuzonEntrada:{
        //   required
        // }
        // ,passwordBuzonEntrada:{
        //   required
        // }
        // , urlBuzonRecepcion:{
        //   required
        //   // , urlFTP
        // }
        // ,usuarioBuzonRecepcion:{
        //   required
        // }
        // ,passwordBuzonRecepcion:{
        //   required
        // }
        // ,puertoBuzonEntrada:{
        //   required
        //   , numeric
        // }
        // ,puertoBuzonRecepcion:{
        //   required
        //   , numeric
        // }
        ,locationAddress:{
          required
          , isCleanEspecialCharacter
        }
        ,locationCity:{
          required
        }
        ,locationRegionCode:{
          required
          /* , numeric */
        }
        ,locationCountryCode:{
          required
          , numeric
        }
        ,locationPostalCode:{
          required
          
        }
        ,consecutivoArchivosGenerados:{
          numeric
        }
        ,numeroComercio:{
          required
          , numeric
        }
        , nombreArchivoCartRefresh:{
          
        }
        , nombreArchivoCartRefreshCarga:{

        }
        // , tiempoMaximoEsperaRespuesta:{
        //   required
        //   , numeric
        //   , minValue: minValue(1)
        //   , maxValue: maxValue(24)
        // }
        // , formatoRespueta:{
        //   required
        // }
        // ,contenidoRespuesta:{
        //   required
        // }
        // , summitterId:{
        //   required
        //   , alphaNumDot
        // }
        // , nombreArchivo:{
        //   required
        // }
        // , nombreArchivoGSFG:{
        //   required
        // }
        // , nombreArchivoRespuesta:{
        //   required
        // }
        , mcc:{
          required
          , maxLength: maxLength(4)
        }
        // , multipleSucursal:{
        //   required
        // }
      }
    }
    , components: {
      VueContentLoading
      , DataTable
      , Auditoria 
    } 
    , mounted(){
      try{
        // this.loadTipoArchivos()
        this.createComponent();
      }catch(e){

      }
    }
    
  }
</script>




// WEBPACK FOOTER //
// src/views/generales/comercio/Sucursal.vue